import { ListingStatus, ListingStrategy } from '@invenco/sales-interface/interfaces';

import { ListingsQueryQuery } from '@/graphql/generated/seller/graphql';
import { convertDateTimeToISO, getEnumValue } from '@/shared/helpers';
import { ListData } from '@/shared/types';

export type ListingListItem = {
  id: string;
  name: string;
  description: string;
  channelName: string;
  qtyExpected: number;
  qtyAvailable: number;
  qtyListed: number;
  createdAt: string;
  updatedAt: string;
  externalSkuName?: string;
  listingStrategy?: ListingStrategy;
  status?: ListingStatus;
};

export class ListingListMapper {
  static toData(response: ListingsQueryQuery): ListData<ListingListItem> {
    const total = response?.listingsAggregate?._count ?? 0;
    const data = Array.isArray(response.listings)
      ? response.listings.map((listing) => ({
          id: listing.id,
          name: listing.name,
          description: listing.description,
          channelName: listing.channelName,
          status: getEnumValue(ListingStatus, listing.status),
          qtyExpected: listing.qtyExpected,
          qtyAvailable: listing.qtyAvailable,
          qtyListed: listing.qtyListed,
          listingStrategy: getEnumValue(ListingStrategy, listing.listingStrategy),
          createdAt: convertDateTimeToISO(listing.createdAt),
          updatedAt: convertDateTimeToISO(listing.updatedAt),
          externalSkuName: listing.externalSkuName || undefined,
        }))
      : [];
    return { data, total };
  }
}
